import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { UserService } from '@forwardflow/services/UserService'

import useSWR from 'swr'
import { useAppStore } from '@forwardflow/store'

export default function useGetUserRole(OrgId?: string) {
   const { currentOrganization } = useAppStore()
   const orgIdRaw = OrgId ? OrgId : currentOrganization
   let orgId: string | null = null

   try {
      orgId = orgIdRaw ? JSON.parse(orgIdRaw) : null
   } catch {
      orgId = orgIdRaw
   }

   const shouldFetch = !!orgId
   const response = useSWR(
      shouldFetch ? [QUERY_KEYS.GET_USER_ORG_ROLE, orgIdRaw] : null,
      () => UserService.getUserRoleInOrganization(orgId as string)
   )

   return {
      ...response,
   }
}
